import React, { useContext } from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { ListContext, cnListBoxItem } from '../utils';
import { getTextPreset } from '../Item/utils';
import { BaseItem } from '../Item/types';
import { HStack } from '../../Stack';
import { TextGenericWithSkin } from '../../TextGeneric/TextGenericWithSkin';

type ItemContentProps = {
    item: BaseItem;
};

export const ItemContent = genericMemo(function ItemContent({ item }: ItemContentProps) {
    const { iconLeft, content, caption, addonRight, isTruncated, addonLeft, help } = item;
    const { size } = useContext(ListContext);
    const textSize = getTextPreset(item);

    const textContent = (
        <TextGenericWithSkin
            isTruncated={isTruncated}
            textSize={textSize}
            skinSize={size}
            color={'current'}
            caption={caption}
            className={cnListBoxItem('overflow')}
            help={help}
        >
            {content}
        </TextGenericWithSkin>
    );

    return (
        <>
            {Boolean(!addonLeft && iconLeft) && <div className={cnListBoxItem('icon', { left: true })}>{iconLeft}</div>}
            {addonRight || addonLeft ? (
                <HStack alignItems={'flex-start'} gap={'current-geometry'} className={cnListBoxItem('overflow')}>
                    {addonLeft}
                    {textContent}
                    {addonRight}
                </HStack>
            ) : (
                textContent
            )}
        </>
    );
});
